import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=7b4bd18a&"
import script from "./Providers.vue?vue&type=script&lang=ts&"
export * from "./Providers.vue?vue&type=script&lang=ts&"
import style0 from "./Providers.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports